module.exports = __webpack_public_path__ + "static/media/Video.8ea4eb55.png";